// V2 /app design tokens (BRIEFS "Common ground"). One place for colours, fonts and the
// app name so later screens look the same.

export const APP_NAME = 'Dream NEET';

export const C = {
  primary: '#4F46E5',
  primaryDark: '#3730A3',
  tint: '#EEF2FF',
  bar: '#1E1B4B',
  bg: '#F8FAFC',
  surface: '#FFFFFF',
  border: '#E2E8F0',
  text: '#0F172A',
  muted: '#475569',
  good: '#047857',
  goodBg: '#D1FAE5',
  bad: '#DC2626',
  badBg: '#FEF2F2',
  streak: '#6B3A06',
  streakBg: '#FDF3E3',
  menuBg: '#F1F5F9',
  noteRed: '#B42318',
  noteBlue: '#1D4ED8',
  noteGreen: '#15803D',
  marker: '#FFF1A8',
};

export const FONT = {
  heading: "Sora, sans-serif",
  ui: "'DM Sans', sans-serif",
  notes: "'Atkinson Hyperlegible', 'Noto Sans Devanagari', 'DM Sans', sans-serif",
  hindi: "'Noto Sans Devanagari', 'Atkinson Hyperlegible', sans-serif",
};

// Buttons are at least 44 px high (grade-4 reader, laptop trackpad).
export const button = {
  primary: {
    minHeight: 46, padding: '0 22px', border: 0, borderRadius: 10,
    background: C.primary, color: '#FFFFFF', fontFamily: FONT.ui,
    fontSize: 16, fontWeight: 600, cursor: 'pointer',
  },
  secondary: {
    minHeight: 46, padding: '0 20px', border: `1px solid ${C.border}`, borderRadius: 10,
    background: C.surface, color: C.text, fontFamily: FONT.ui,
    fontSize: 15, fontWeight: 500, cursor: 'pointer',
  },
};
